import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { DarkModeService } from '@okcargo-apps/layout-ionic';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-menu-header',
  templateUrl: './menu-header.component.html',
  styleUrls: ['./menu-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonHeader, IonToolbar, IonTitle, TranslateModule],
})
export class MenuHeaderComponent {
  private readonly darkModeService = inject(DarkModeService);

  public readonly APP_NAME_TAGLINE = environment.appNameTagline;

  // constructor() {}

  public logoSrc = this.darkModeService.logoSrc;
}
